import { render, staticRenderFns } from "./SectionsToFinishFilter.vue?vue&type=template&id=2bc85f34&scoped=true"
import script from "./SectionsToFinishFilter.vue?vue&type=script&lang=js"
export * from "./SectionsToFinishFilter.vue?vue&type=script&lang=js"
import style0 from "./SectionsToFinishFilter.vue?vue&type=style&index=0&id=2bc85f34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc85f34",
  null
  
)

export default component.exports